export {default} from './icon'



// WEBPACK FOOTER //
// ./~/muse-ui/src/icon/index.js